var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSuccessBadge(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C8.85652 14 10.637 13.2625 11.9497 11.9497C13.2625 10.637 14 8.85652 14 7C14 5.14348 13.2625 3.36301 11.9497 2.05025C10.637 0.737498 8.85652 0 7 0C5.14348 0 3.36301 0.737498 2.05025 2.05025C0.737498 3.36301 0 5.14348 0 7C0 8.85652 0.737498 10.637 2.05025 11.9497C3.36301 13.2625 5.14348 14 7 14ZM10.2436 5.86862L6.741 9.36862C6.65974 9.44998 6.56323 9.51452 6.45701 9.55855C6.35079 9.60259 6.23693 9.62525 6.12194 9.62525C6.00695 9.62525 5.89309 9.60259 5.78686 9.55855C5.68064 9.51452 5.58414 9.44998 5.50287 9.36862L3.7555 7.61862C3.59143 7.45432 3.49935 7.23157 3.49951 6.99938C3.49968 6.76719 3.59207 6.54457 3.75638 6.3805C3.92068 6.21643 4.14343 6.12435 4.37562 6.12451C4.60781 6.12468 4.83043 6.21707 4.9945 6.38138L6.12325 7.51275L9.00638 4.63138C9.1714 4.47199 9.39243 4.38379 9.62185 4.38579C9.85127 4.38778 10.0707 4.4798 10.233 4.64203C10.3952 4.80427 10.4872 5.02373 10.4892 5.25315C10.4912 5.48257 10.403 5.7036 10.2436 5.86862Z",
    fill: "#43A379"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccessBadge);
export default __webpack_public_path__ + "static/media/ic_success_badge.13d22c6c.svg";
export { ForwardRef as ReactComponent };